module.exports = __webpack_public_path__ + "img/resv.de360eb5.png";